import SoonPage from "../SoonPage";

const ControleFinanceiroPage = ({ selected }) => {
  return <SoonPage selected={"comissoes"} />;
};

export default ControleFinanceiroPage;
